import { useState, useCallback } from 'react';
import { backendClient } from '@/lib/api-client';
import { CategoryGroup } from '../types';

export function useCrimsonPrompts(slug: string | undefined) {
  const [crimsonGroups, setCrimsonGroups] = useState<CategoryGroup[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCrimsonPrompts = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await backendClient.get('/case-partner/prompt-library', {
        params: slug ? { matter_guid: slug } : {},
      });
      const library: Record<string, Record<string, string>> = response.data?.library || {};
      setCrimsonGroups(
        Object.entries(library).map(([category, prompts]) => ({
          categoryKey: category,
          categoryName: category,
          prompts: Object.entries(prompts).map(([key, value]) => ({
            key,
            title: key,
            content: value,
            categoryName: category,
            canManage: false,
          })),
        }))
      );
    } catch (error) {
      console.error('Error fetching prompt library:', error);
    } finally {
      setIsLoading(false);
    }
  }, [slug]);

  return { crimsonGroups, isLoading, fetchCrimsonPrompts };
}
